import React from 'react';
import type CustomFieldsDirectoryAdminType from '@atlassian/jira-spa-apps-admin-pages-custom-fields-directory/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyCustomFieldsDirectoryAdmin = lazyForPaint<typeof CustomFieldsDirectoryAdminType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-admin-pages-custom-fields-directory", jiraSpaEntry: "async-admin-pages-custom-fields-directory" */ '@atlassian/jira-spa-apps-admin-pages-custom-fields-directory'
			),
		),
);

const AsyncCustomFieldsDirectoryAdmin = (): React.JSX.Element => (
	<LazyPage
		Page={LazyCustomFieldsDirectoryAdmin}
		pageId="admin-pages-custom-fields-directory"
		shouldShowSpinner
	/>
);

export default AsyncCustomFieldsDirectoryAdmin;
